import { render, staticRenderFns } from "./MobileLinks.vue?vue&type=template&id=2d090b8d&scoped=true"
import script from "./MobileLinks.vue?vue&type=script&lang=js"
export * from "./MobileLinks.vue?vue&type=script&lang=js"
import style0 from "./MobileLinks.vue?vue&type=style&index=0&id=2d090b8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d090b8d",
  null
  
)

export default component.exports